/**
 * Lightweight API Error class to replace @hapi/boom
 */
export class ApiError extends Error {
  public readonly statusCode: number
  public readonly data?: unknown

  constructor(message: string, statusCode: number, data?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.statusCode = statusCode
    this.data = data
  }
}
